// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__grdIK","logo":"Footer_logo__l7F6G","logoText":"Footer_logoText__3OzBU","rights":"Footer_rights__7MPE2","socials":"Footer_socials__n56cC"};